import { useContext } from 'react';
import { RecapContext } from './RecapContext';

export const useRecapContext = () => useContext(RecapContext);

